import { useState, useEffect, useCallback } from 'react';

export function useCampaignProgress(campaignType, workspaceId, queryClient, queryKey) {
  const [liveProgress, setLiveProgress] = useState({});

  useEffect(() => {
    if (!workspaceId) return undefined;

    const handler = (e) => {
      const data = e.detail;
      if (!data || data.workspaceId !== workspaceId) return;
      if (data.campaignType !== campaignType) return;

      setLiveProgress((prev) => {
        const existing = prev[data.campaignId];
        if (
          existing?.executionId &&
          data.executionId &&
          Number(data.executionId) < Number(existing.executionId)
        ) {
          return prev;
        }
        return {
          ...prev,
          [data.campaignId]: data
        };
      });

      if (data.status === 'completed' || data.status === 'failed' || data.status === 'cancelled') {
        queryClient.invalidateQueries(queryKey);
        setTimeout(() => {
          setLiveProgress((prev) => {
            const next = { ...prev };
            delete next[data.campaignId];
            return next;
          });
        }, 3000);
      }
    };

    window.addEventListener('sse:campaign-progress', handler);
    return () => window.removeEventListener('sse:campaign-progress', handler);
  }, [workspaceId, campaignType, queryClient, queryKey]);

  const getProgress = useCallback((campaign) => {
    const live = liveProgress[campaign.id];
    if (live) return live;
    return campaign.execution_progress || null;
  }, [liveProgress]);

  return { getProgress };
}
